import { Popover } from '@material-ui/core';
import React, { useContext } from 'react';
import { FilterBox } from './FilterBox/FilterBox';
import classes from './AppTableFilterPopover.module.scss';
import { AppTableContext } from '../../AppTableContext';
import { FilterTypes, WMTableColumnShape } from '../../WMTable/WMTable';

export type EditFilter = {
    anchorEl: HTMLElement;
    dataKey: string;
    title: string;
    renderFilterItem?: WMTableColumnShape['renderFilterItem'];
    type?: FilterTypes;
};

export const AppTableFilterPopover = ({ editFilter, onClose }: { editFilter: EditFilter | null; onClose: () => void }) => {
    const { filtersList } = useContext(AppTableContext);
    const anchorEl = editFilter?.anchorEl || null;
    const dataKey = editFilter?.dataKey;
    const title = editFilter?.title;
    const renderFilterItem = editFilter?.renderFilterItem;
    const type = editFilter?.type;

    return (
        <Popover
            open={!!anchorEl}
            anchorEl={anchorEl}
            onClose={onClose}
            classes={{
                paper: classes.paper
            }}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right'
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right'
            }}
        >
            {dataKey && title && (
                <FilterBox type={type} filters={filtersList[dataKey!]} dataKey={dataKey!} filterTitle={title} renderFilterItem={renderFilterItem} />
            )}
        </Popover>
    );
};
